const gregorian_en_lowercase = {
  name: 'gregorian_en_lowercase',
  months: [
    ['januari', 'jan'],
    ['februari', 'feb'],
    ['mars', 'mar'],
    ['april', 'apr'],
    ['maj', 'maj'],
    ['juni', 'jun'],
    ['juli', 'jul'],
    ['augusti', 'aug'],
    ['september', 'sep'],
    ['oktober', 'okt'],
    ['november', 'nov'],
    ['december', 'dec'],
  ],
  weekDays: [
    ['lördag', 'lö'],
    ['söndag', 'sö'],
    ['måndag', 'må'],
    ['tisdag', 'ti'],
    ['onsdag', 'on'],
    ['torsdag', 'to'],
    ['fredag', 'fr'],
  ],
  digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  meridiems: [
    ['AM', 'am'],
    ['PM', 'pm'],
  ],
};

export default gregorian_en_lowercase;
